import * as yup from 'yup'

// Liên hệ trong trường hợp khẩn cấp: bắt buộc Quan hệ + Số điện thoại
export const emergencyContactSchema = () =>
    yup
        .array()
        .of(
            yup.object({
                contact_relationship: yup
                    .string()
                    .trim()
                    .required('Emergency contact relationship is required'),
                contact_phone: yup
                    .string()
                    .trim()
                    .matches(/^[0-9+\-\s()]+$/, 'Invalid phone number format')
                    .min(10, 'Phone number must be at least 10 digits')
                    .required('Emergency contact phone is required'),
            })
        )
        .min(1, 'Emergency contact is required')
        .required('Emergency contact is required')

// Personal Tab Schema
// `requireEmergencyContact` chỉ bật ở form điền link (onboarding) để bắt buộc
// liên hệ khẩn cấp ngay tab đầu; account/info dùng mặc định (không bắt buộc).
export const personalTabSchema = ({
    requireEmergencyContact = false,
}: { requireEmergencyContact?: boolean } = {}) =>
    yup.object({
        employee_email: yup
            .string()
            .email('Invalid email format')
            .required('Email is required'),
        employee_phone_number: yup
            .string()
            .matches(/^[0-9+\-\s()]+$/, 'Invalid phone number format')
            .min(10, 'Phone number must be at least 10 digits')
            .required('Phone number is required'),
        employee_birthday: yup.string().required('Birthday is required'),
        employee_gender: yup.string().required('Gender is required'),
        employee_marriage: yup.string().optional(),
        employee_birthplace: yup.string().optional(),
        employee_nationality: yup.string().optional(),
        employee_religion: yup.string().optional(),
        employee_nation: yup.string().optional(),
        employee_original_place: yup.string().optional(),
        ...(requireEmergencyContact
            ? { contact_homies: emergencyContactSchema() }
            : {}),
    })

// Identification Tab Schema
export const identificationTabSchema = () =>
    yup.object({
        employee_idno: yup
            .string()
            .matches(/^[0-9]+$/, 'ID number must contain only numbers')
            .min(9, 'ID number must be at least 9 digits')
            .max(12, 'ID number cannot exceed 12 digits')
            .required('ID number is required'),
        employee_idno_issued_on: yup
            .string()
            .required('ID issued date is required'),
        employee_idno_issued_by: yup
            .string()
            .min(3, 'Issued by must be at least 3 characters')
            .required('ID issued by is required'),
    })

// Address Tab Schema
export const addressTabSchema = () =>
    yup.object({
        employee_country: yup.string().required('Country is required'),
        employee_city: yup.string().required('City is required'),
        employee_district: yup.string().required('District is required'),
        employee_ward: yup.string().optional(),
        employee_street: yup
            .string()
            .min(5, 'Street address must be at least 5 characters')
            .required('Street address is required'),
        employee_temporary_city: yup
            .string()
            .when('temporary_same_as_permanent', {
                is: false,
                then: (schema) => schema.required('Temporary city is required'),
                otherwise: (schema) => schema.optional(),
            }),
        employee_temporary_district: yup
            .string()
            .when('temporary_same_as_permanent', {
                is: false,
                then: (schema) =>
                    schema.required('Temporary district is required'),
                otherwise: (schema) => schema.optional(),
            }),
        employee_temporary_street: yup
            .string()
            .when('temporary_same_as_permanent', {
                is: false,
                then: (schema) =>
                    schema
                        .min(
                            5,
                            'Temporary street address must be at least 5 characters'
                        )
                        .required('Temporary street address is required'),
                otherwise: (schema) => schema.optional(),
            }),
        temporary_same_as_permanent: yup.boolean().default(false),
    })

// Finance Tab Schema
export const financeTabSchema = () =>
    yup.object({
        // employee_bank_name: yup
        //     .string()
        //     .min(2, 'Bank name must be at least 2 characters')
        //     .required('Bank name is required'),
        // employee_bank_branch: yup
        //     .string()
        //     .min(3, 'Bank branch must be at least 3 characters')
        //     .optional(),
        // employee_bank_number: yup
        //     .string()
        //     .matches(
        //         /^[0-9]+$/,
        //         'Bank account number must contain only numbers'
        //     )
        //     .min(8, 'Bank account number must be at least 8 digits')
        //     .max(20, 'Bank account number cannot exceed 20 digits')
        //     .optional(),
        // employee_personal_tax_code: yup
        //     .string()
        //     .matches(
        //         /^[0-9\-]+$/,
        //         'Tax code must contain only numbers and dashes'
        //     )
        //     .min(10, 'Tax code must be at least 10 characters')
        //     .max(15, 'Tax code cannot exceed 15 characters')
        //     .optional(),
    })

// Experience Tab Schema
export const experienceTabSchema = () =>
    yup.object({
        employee_university: yup
            .string()
            .min(3, 'University name must be at least 3 characters')
            .required('University is required'),
        employee_major: yup
            .string()
            .min(3, 'Major must be at least 3 characters')
            .required('Major is required'),
        employee_experience: yup.string().optional(),
        attendances: yup
            .array()
            .of(
                yup.object({
                    name: yup
                        .string()
                        .min(2, 'Name must be at least 2 characters')
                        .max(100, 'Name cannot exceed 100 characters')
                        .required('Attendance name is required'),
                    description: yup
                        .string()
                        .min(5, 'Description must be at least 5 characters')
                        .max(500, 'Description cannot exceed 500 characters')
                        .required('Attendance description is required'),
                })
            )
            .optional()
            .default([]),
    })

// Profile Tab Schema
export const profileTabSchema = () => yup.object({})

// Contact Homies Schema
export const contactHomiesSchema = () =>
    yup
        .array()
        .of(
            yup.object({
                contact_name: yup
                    .string()
                    .min(2, 'Contact name must be at least 2 characters')
                    .required('Contact name is required'),
                contact_phone: yup
                    .string()
                    .matches(/^[0-9+\-\s()]+$/, 'Invalid phone number format')
                    .min(10, 'Phone number must be at least 10 digits')
                    .required('Contact phone is required'),
                contact_relationship: yup
                    .string()
                    .min(2, 'Relationship must be at least 2 characters')
                    .required('Relationship is required'),
            })
        )
        .optional()
        .default([])

// Complete Employee Form Schema
export const employeeFormSchema = () =>
    yup.object({
        // Combine all tab schemas
        ...personalTabSchema().fields,
        ...identificationTabSchema().fields,
        ...addressTabSchema().fields,
        ...financeTabSchema().fields,
        ...experienceTabSchema().fields,
        ...profileTabSchema().fields,

        // Additional fields
        contact_homies: contactHomiesSchema(),
        documents: yup
            .array()
            .of(
                yup.object({
                    document_type: yup
                        .string()
                        .required('Document type is required'),
                    file: yup.mixed().nullable(),
                })
            )
            .optional()
            .default([]),
    })

// Step validation helper functions
export const validateStep = ({ activeTab, requireEmergencyContact }: any) => {
    const getSchemaForStep = (stepName: string) => {
        switch (stepName) {
            case 'Personal':
                return personalTabSchema({ requireEmergencyContact })
            case 'Identification':
                return identificationTabSchema()
            case 'Address':
                return addressTabSchema()
            case 'Finance':
                return financeTabSchema()
            case 'Experience':
                return experienceTabSchema()
            case 'Profile':
                return profileTabSchema()
            default:
                return employeeFormSchema()
        }
    }

    return getSchemaForStep(activeTab)
}

// Get validation resolver for react-hook-form
export const getValidationResolver = () => {
    return async (data: any) => {
        try {
            await employeeFormSchema().validate(data, { abortEarly: false })
            return { values: data, errors: {} }
        } catch (error) {
            if (error instanceof yup.ValidationError) {
                const errors: Record<string, any> = {}
                error.inner.forEach((err) => {
                    if (err.path) {
                        errors[err.path] = { message: err.message }
                    }
                })
                return { values: {}, errors }
            }
            return { values: {}, errors: {} }
        }
    }
}
